<div>
  <span class="dialog-close" (click)="this.activeModal.close()">X</span>
  <div class="d-flex flex-column justfiy-content-center align-items-center modal-container">
    <h4 class="modal-body">You already have an item inside your cart.</h4>
    <div class="modal-footer">
      <button class="btn btn-primary btn-round" (click)="onConfirm()">View cart</button>
    </div>
  </div>
</div>
